import { useState, useRef, useCallback } from 'react';

function useExpandableImage(heightThreshold = 800, ratioThreshold = 1.5) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [needsExpansion, setNeedsExpansion] = useState(false);
    const containerRef = useRef(null);

    const onImageLoad = useCallback((e) => {
        const { naturalHeight, naturalWidth } = e.target;
        if (naturalHeight > heightThreshold || (naturalHeight / naturalWidth > ratioThreshold)) {
            setNeedsExpansion(true);
        }
    }, [heightThreshold, ratioThreshold]);

    const toggleExpand = useCallback(() => {
        if (isExpanded && containerRef.current) {
            containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        setIsExpanded(prev => !prev);
    }, [isExpanded]);

    return { isExpanded, needsExpansion, containerRef, onImageLoad, toggleExpand };
}

export default useExpandableImage;
